<template>
  <div class="service-banner">
    <div class="service-banner-img" :style="{backgroundImage:'url('+imgUrl+')'}">
    </div>
    <div class="title1">{{title1}}<span class="title-en">{{titleEn}}</span></div>
    <div class="title2">{{title2}}</div>
  </div>
</template>

<script>
  export default {
    name: "CBanner",
    props: {
      imgUrl: {
        type: String
      },
      title1:{
        type:String
      },
      title2:{
        type:String
      },
      titleEn:{
       type:String
      }
    }
  }
</script>

<style scoped>
  .service-banner {
    width: 100%;
    height: 400px;
    min-width: 1200px;
    position: relative;
  }

  .service-banner-img {
    width: 1920px;
    height: 400px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
    background-size: cover;
  }
  .title-en{
    font-size: 20px;
    font-family: Roboto-Light, Roboto;
    font-weight: 300;
    color: #fff;
    opacity: 0.6;
    margin-left: 10px;
  }
  .service-banner .title1{
    font-size: 32px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 48px;
    position: absolute;
    top: 190px;
    left: 50%;
    margin-left: -514px;
  }
  .service-banner .title2{
    font-size: 16px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
    position: absolute;
    top: 260px;
    left: 50%;
    width: 308px;
    margin-left: -514px;
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// src/components/CBanner.vue